export function GetInitialStartDateForFilter() {
  return new Date(new Date().getFullYear(), 0, 1);
}

export function GetInitialEndDateForFilter() {
  return new Date(new Date().getFullYear(), 11, 31);
}